<template>
  <div class="ddk-container">
    <el-row class="tcf-row" v-loading.fullscreen.lock="fullscreenLoading">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            待打款
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
            </div>
          </div>
          <div class="card-content" >
            <el-row>
              <el-col :span="5">
                <ul class="group-filter">
                  <li :class="type===0?'active':''" @click="change(0)">未打款</li>
                  <li :class="type===1?'active':''" @click="change(1)">待审核</li>
                  <li :class="type===2?'active':''" @click="change(2)">审核通过</li>
                </ul>
              </el-col>
              <el-col :span="19" v-loading="loading">
                <el-table
                  :data="tableData"
                  :show-header="false"
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="客户名称"
                    width="200"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0&&scope.row.paymark===0" type="danger">待打款</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===0&&scope.row.paymark===2" type="danger">审核拒绝</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===1" type="warning">待审核</el-tag>
                      <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2">已审核</el-tag>
                      <span style="color:#000;margin-left: 6px;">{{scope.row.all_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="签订时间"
                    width="140"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span><i class="el-icon-time"></i> {{scope.row.time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="签订合同"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span><i class="el-icon-document"></i> {{scope.row.contract_name}}（{{scope.row.code}}）</span>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editTitle"
      :visible.sync="editVisible"
      width="40%"
      top="10vh"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form ref="editForm" :model="editForm" :rules="editRules"  label-position="right" label-width="75px" size="small">
        <el-form-item label="审核信息" v-if="audittime!=null&&audittime!=''">
          <el-card class="box-card">
            <div style="color:#606266;font-size: 13px;">
              <span><span style="color:#99a9bf">审核时间：</span>{{audittime}}</span>
              <span style="margin-left: 30px;"><span style="color:#99a9bf">审核人：</span>{{auditname}}</span>
            </div>
            <div style="color:#606266;font-size: 13px;" v-if="auditrson!=''&&auditrson!=null">
              <span style="color:#99a9bf">拒绝原因：</span>{{auditrson}}
            </div>
          </el-card>
        </el-form-item>
        <el-form-item label="客户" prop="clientname">
          <el-input
            v-model="editForm.clientname"
            :disabled="true">
          </el-input>
        </el-form-item>
        <el-form-item label="打款账户" prop="accountid">
          <el-select v-model="editForm.accountid" style="width:100%" placeholder="请选择" clearable filterable>
            <el-option-group
              v-for="gitem in groupList"
              v-if="gitem.nature===0"
              :key="gitem.groupid"
              :label="gitem.account_name">
              <el-option
                v-for="item in accountsList"
                v-if="item.groupid===gitem.groupid"
                :key="item.aid"
                :label="item.name+'（'+item.card+'）'"
                :value="item.aid">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.card }}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="打款日期" prop="date">
          <el-date-picker
            v-model="editForm.date"
            type="date"
            style="width:240px"
            format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="打款金额" prop="price">
          <el-input v-model="editForm.price" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="样品预存款" prop="joins">
          <el-input v-model="editForm.joins" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="加盟费" prop="insure">
          <el-input v-model="editForm.insure" oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px"><template slot="append">元</template></el-input>
        </el-form-item>
        <el-form-item label="卡号" prop="card">
          <el-input v-model="editForm.card" maxlength="100" placeholder="请输入汇款人“卡号/尾号”，例如“张三/1234”" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="打款凭证" prop="imgids">
          <MultiImg :limit="9" :size="'sm'" :old="editimgList" :key="imgLoad" v-model="editForm.imgids" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="editForm.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button type="primary" :loading="editloading" @click="subEdit('editForm')">立即提交</el-button>
          <el-button @click="editVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="招商收款详细"
      :visible.sync="infoVisible"
      width="40%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <table class="tcf-detail-table" v-loading="fullinfoLoading">
        <tr>
          <th>申请人</th>
          <td>{{ infoList.apply_name }}</td>
          <th>申请时间</th>
          <td>{{ infoList.time }}</td>
        </tr>
        <tr>
          <th>客户</th>
          <td>{{ infoList.all_name }}</td>
          <th>卡号</th>
          <td>{{ infoList.card_num }}</td>
        </tr>
        <tr>
          <th>打款账户</th>
          <td colspan="3"><span v-for="av in infoList.accountVoList" v-if="av.is_select===1">{{av.account_name}}（{{av.card}}）</span></td>
        </tr>
        <tr>
          <th>打款日期</th>
          <td>{{ infoList.pay_time }}</td>
          <th>打款金额</th>
          <td>{{ infoList.pay_price }}（样品预存款：{{ infoList.joins }}，加盟费：{{ infoList.insure }}）</td>
        </tr>
        <tr>
          <th>打款凭证</th>
          <td colspan="3">
            <el-image v-for="iurl in imgSrcList"
                      style="width: 60px; height: 60px;margin-right: 10px;margin-bottom: 10px"
                      :src="iurl"
                      :preview-src-list="imgSrcList">
            </el-image>
          </td>
        </tr>
        <tr>
          <th>备注</th>
          <td colspan="3">{{ infoList.remark }}</td>
        </tr>
        <tr>
          <th>审核人</th>
          <td>{{ infoList.auditname }}</td>
          <th>审核时间</th>
          <td>{{ infoList.audittime }}</td>
        </tr>
      </table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="infoVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getWaitPayList, addOrUpdateWaitPay, addOrEditWaitPay, getMerchantsMoneyDetail } from '@/api/work'
import { getAccounts, getGroupReport } from '@/api/pub'
import MultiImg from '@/components/upload/MultiImg'

export default {
  name: 'ddk',
  computed: {
    user: getUser
  },
  components: {
    MultiImg
  },
  data() {
    return {
      fullscreenLoading: false,
      search: '',
      type: 0,
      loading: false,
      editloading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editVisible: false,
      editTitle: '招商打款',
      groupList: [],
      accountsList: [],
      imgLoad: '',
      editimgList: [],
      auditrson: '',
      auditname: '',
      audittime: '',
      editForm: {
        signid: '',
        clientname: '',
        accountid: '',
        date: '',
        price: null,
        card: '',
        imgids: [],
        remark: '',
        payid: 0,
        joins: null,
        insure: null
      },
      editRules: {
        clientname: [{ required: true, message: '请选择要打款的客户', trigger: 'change' }],
        accountid: [{ required: true, message: '请选择打款账户', trigger: 'change' }],
        date: [{ required: true, message: '请选择打款日期', trigger: 'change' }],
        price: [{ required: true, message: '请输入打款金额', trigger: 'blur' }],
        joins: [{ required: true, message: '请输入样品预存款', trigger: 'blur' }],
        insure: [{ required: true, message: '请输入加盟费', trigger: 'blur' }],
        card: [{ required: true, message: '请输入汇款人卡号', trigger: 'blur' }],
        imgids: [{ required: true, message: '请上传打款凭证', trigger: 'change' }]
      },
      infoVisible: false,
      infoList: [],
      imgSrcList: [],
      fullinfoLoading: false
    }
  },
  created() {
    this.getData()
    getGroupReport().then(response => {
      this.groupList = response.data
    }).catch(() => {})
    getAccounts().then(response => {
      this.accountsList = response.data
    }).catch(() => {})
  },
  methods: {
    change(n) {
      if (this.type === n) {
        return false
      }
      this.type = n
      this.getData()
    },
    Search() {
      if (this.search != null && this.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        type: this.type,
        userid: this.user.dUserid,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize
      }
      getWaitPayList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      if (row.mark === 2) {
        this.imgSrcList = []
        this.infoVisible = true
        this.fullinfoLoading = true
        getMerchantsMoneyDetail({ payid: row.pay_id, userid: this.user.dUserid }).then(response => {
          this.fullinfoLoading = false
          this.infoList = response.data
          let imgs = []
          for (let c of this.infoList.imgList) {
            imgs.push(c.img_url)
          }
          this.imgSrcList = imgs
        }).catch(() => {
          this.fullinfoLoading = false
        })
      } else {
        this.editForm.signid = row.sign_id
        this.editForm.clientname = row.all_name
        this.editimgList = []
        this.auditrson = ''
        this.auditname = ''
        this.audittime = ''
        if (row.pay_id !== 0 && row.pay_id !== null && row.pay_id !== '' && row.pay_id !== undefined) {
          this.editTitle = '编辑招商收款'
          this.fullscreenLoading = true
          addOrEditWaitPay({ payid: row.pay_id, userid: this.user.dUserid, sign_id: row.sign_id }).then(response => {
            this.editForm.accountid = response.data.account_id
            this.editForm.date = response.data.pay_time
            this.editForm.price = response.data.pay_price
            this.editForm.card = response.data.card_num
            this.auditrson = response.data.rson
            this.auditname = response.data.auditname
            this.audittime = response.data.audittime
            this.editForm.joins = response.data.joins
            this.editForm.insure = response.data.insure
            let oldimgList = []
            for (let img of response.data.imgList) {
              oldimgList.push({ id: img.img_id, url: img.img_url })
            }
            this.editimgList = oldimgList
            this.imgLoad = new Date().getTime()
            this.editForm.remark = response.data.remark
            this.editForm.payid = response.data.pay_id
            this.fullscreenLoading = false
            this.editVisible = true
          }).catch(() => {
            this.fullscreenLoading = false
            this.editVisible = false
          })
        } else {
          this.editTitle = '招商收款'
          this.imgLoad = new Date().getTime()
          this.editForm.accountid = ''
          this.editForm.date = ''
          this.editForm.price = null
          this.editForm.joins = null
          this.editForm.insure = null
          this.editForm.card = ''
          this.editForm.imgids = []
          this.editForm.remark = ''
          this.editForm.payid = 0
          this.editVisible = true
        }
      }
    },
    subEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.editloading) {
            this.editloading = true
            const data = {
              userid: this.user.dUserid,
              payid: this.editForm.payid,
              signid: this.editForm.signid,
              date: this.editForm.date,
              price: this.editForm.price,
              accountid: this.editForm.accountid,
              card: this.editForm.card,
              imgStr: this.editForm.imgids.join(','),
              remark: this.editForm.remark,
              join: this.editForm.joins,
              insure: this.editForm.insure
            }
            // console.log(this.editForm)
            addOrUpdateWaitPay(data).then(response => {
              this.$message({
                message: '打款凭证提交成功',
                type: 'success'
              })
              this.editVisible = false
              this.editloading = false
              this.editimgList = []
              this.getData()
            }).catch(() => {
              this.editloading = false
            })
          } else {
            return false
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ddk-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .client-sex{
            width: 16px!important;
            height: 16px!important;
            vertical-align: -4px!important;
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
